import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 16 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 10\" id=\"icon-arrow--cta\"><path d=\"M15 4.423a.577.577 0 1 1 0 1.154V4.423ZM.592 5.408a.577.577 0 0 1 0-.816L4.266.918a.577.577 0 0 1 .816.816L1.817 5l3.265 3.266a.577.577 0 1 1-.816.816L.592 5.408ZM15 5.578H1V4.422h14v1.154Z\" fill=\"#034E1D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol